// extracted by mini-css-extract-plugin
module.exports = {"userBlock":"Menu_userBlock__rytPV","wrapper":"Menu_wrapper__2hoUg","userName":"Menu_userName__3Rg7B","logBtn":"Menu_logBtn__1QTWI","hide":"Menu_hide__3rPkD"};